export const GET_LIST_REPORTS = 'GET_LIST_REPORTS';
export const GET_LIST_REPORTS_SUCCESS = 'GET_LIST_REPORTS_SUCCESS';
export const GET_LIST_REPORTS_FAIL = 'GET_LIST_REPORTS_FAIL';

export const GET_REPORT_CREATE = 'GET_REPORT_CREATE';
export const GET_REPORT_CREATE_NEW = 'GET_REPORT_CREATE_NEW';
export const GET_REPORT_CREATE_SUCCESS = 'GET_REPORT_CREATE_SUCCESS';
export const GET_REPORT_CREATE_FAIL = 'GET_REPORT_CREATE_FAIL';

export const GET_REPORT_ERROR_CLOSE = 'GET_REPORT_ERROR_CLOSE';

export const GET_REPORT_TYPES = 'GET_REPORT_TYPES';
export const GET_REPORT_TYPES_SUCCESS = 'GET_REPORT_TYPES_SUCCESS';
export const GET_REPORT_TYPES_FAIL = 'GET_REPORT_TYPES_FAIL';

export const GET_REPORT_PRODUCT_TYPES = 'GET_REPORT_PRODUCT_TYPES';
export const GET_REPORT_PRODUCT_TYPES_SUCCESS = 'GET_REPORT_PRODUCT_TYPES_SUCCESS';
export const GET_REPORT_PRODUCT_TYPES_FAIL = 'GET_REPORT_PRODUCT_TYPES_FAIL';

export const GET_REPORT_USERS = 'GET_REPORT_USER';
export const GET_REPORT_USERS_SUCCESS = 'GET_REPORT_USER_SUCCESS';
export const GET_REPORT_USERS_FAIL = 'GET_REPORT_USER_FAIL';

export const SET_INITIAL_STATE_REPORT = 'SET_INITIAL_STATE_REPORT';
